module.exports = __webpack_public_path__ + "images/logo-footer@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-footer@2x.png
// module id = 816m
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13